import { useSyncExternalStore } from 'react'

export type CurrentSession = {
  sessionId: string | null
  courseId?: number | string | null
  moduleId?: number | string | null
  conceptId?: number | string | null
}

const EMPTY: CurrentSession = { sessionId: null }

let current: CurrentSession = EMPTY
const listeners = new Set<() => void>()

function emit() {
  listeners.forEach((l) => l())
}

export function setCurrentSession(info: CurrentSession | null): void {
  current = info ?? EMPTY
  emit()
}

export function clearCurrentSession(): void {
  if (current === EMPTY) return
  current = EMPTY
  emit()
}

export function getCurrentSession(): CurrentSession {
  return current
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

export function useCurrentSession(): CurrentSession {
  return useSyncExternalStore(subscribe, getCurrentSession, getCurrentSession)
}
